import { render } from "./TextEllipsis.vue?vue&type=template&id=b29b3b64&scoped=true"
import script from "./TextEllipsis.vue?vue&type=script&setup=true&lang=js"
export * from "./TextEllipsis.vue?vue&type=script&setup=true&lang=js"

import "./TextEllipsis.vue?vue&type=style&index=0&id=b29b3b64&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b29b3b64"],['__file',"src/components/TextEllipsis.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b29b3b64"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b29b3b64', __exports__)) {
    console.log('reload')
    api.reload('b29b3b64', __exports__)
  }
  
  module.hot.accept("./TextEllipsis.vue?vue&type=template&id=b29b3b64&scoped=true", () => {
    console.log('re-render')
    api.rerender('b29b3b64', render)
  })

}


export default __exports__